import { ProfileTabs } from ".";

const ProfileContent = () => {
	return (
		<>
			<main className="main flex-column align-center flex-gap-1">
				<ProfileTabs />
			</main>
		</>
	);
};

export { ProfileContent };
